module.exports = __webpack_public_path__ + "img/jiangpin.789f5205.png";